import { DateTime } from 'luxon';

export const calculateBillingPeriod = (
  billingPeriod?: string,
  billingAmount?: number,
  rawDateFrom?: string,
  rawDateTo?: string
) => {
  if (billingPeriod && billingAmount && rawDateFrom && rawDateTo) {
    const dateFrom = DateTime.fromISO(rawDateFrom);
    const dateTo = DateTime.fromISO(rawDateTo);
    const diffDays = dateTo.diff(dateFrom, ['days']).days + 1;

    const paymentsPerPeriod = new Map();
    paymentsPerPeriod.set('Annual', 1);
    paymentsPerPeriod.set('Semi Annual', 2);
    paymentsPerPeriod.set('Quarterly', 4);
    paymentsPerPeriod.set('Monthly', 12);

    const numberOfPayments = paymentsPerPeriod.get(billingPeriod);
    const monthsPerPayment = 12 / numberOfPayments;
    const startMonth = dateFrom.month;
    const startYear = dateFrom.year;

    let startPeriodMonth;

    if (startMonth % monthsPerPayment > 0) {
      startPeriodMonth = Math.floor(startMonth / monthsPerPayment) * monthsPerPayment + 1;
    } else {
      startPeriodMonth = (startMonth / monthsPerPayment - 1) * monthsPerPayment + 1;
    }
    const endPeriodMonth = startPeriodMonth - 1 + monthsPerPayment;
    const startPeriodDate = DateTime.utc(startYear, startPeriodMonth, 1);
    const endPeriodDate = DateTime.utc(startYear, endPeriodMonth, 1).plus({ months: 1 }).minus({ days: 1 });
    const periodDays = endPeriodDate.diff(startPeriodDate, ['days']).days + 1;
    const amount = billingAmount * (diffDays / periodDays);
    return amount;
  }
  return undefined;
};
